module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<select class="select2"\n    ';
 if (options.multipleSelectionsAllowed) { 
__p+='\n    multiple="multiple"\n    ';
 } 
__p+='\n    name="'+
((__t=( options.modelAttr ))==null?'':_.escape(__t))+
'"\n    style="width: '+
((__t=( options.width ))==null?'':_.escape(__t))+
'"></select>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/dropdown-list/dropdown-list.tpl
 ** module id = 44
 ** module chunks = 1 2 3 4 5 6 7 8 10 11 12 13 17 18 19 20 21 22 24 25 26 30 33 34 35 36 41 43 47 52 63 64 71 72 73 74 81 89 92 93 97 100 129
 **/